import CreateNote from 'app/features/notes/CreateNote';
import NoteCard from 'app/features/notes/NoteCard';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { useLazyGetNotesQuery } from 'app/services/notes';
import PaginatedList from 'Components/Pagination/PaginatedList';
import usePagination from 'Components/Pagination/usePagination';

export default function DocumentNotes({ documentId }: { documentId: number }) {
  const { PaginationContextProvider, data, Pagination } = usePagination(
    useLazyGetNotesQuery,
    {
      per_page: 3,
      filters: {
        document_id: documentId,
      },
    },
    {
      skipQueryParamsCache: true,
    },
  );

  return (
    <PaginationContextProvider>
      <ScrollContainer className="mt-2 gap-2 px-2">
        <CreateNote documentId={documentId} label={'Comment'} />
        <PaginatedList
          data={data}
          Pagination={Pagination}
          renderItem={(value) => (
            <div>
              <NoteCard value={value} label={'Comment'} />
            </div>
          )}
        />
      </ScrollContainer>
    </PaginationContextProvider>
  );
}
